import { keysOf } from '@upright/common/utils';
import { keyBy, mapValues } from 'lodash';
import { SubscriptionTier } from '../../../../../common/activities/contact-forms/company-subscription/subscription-tiers';

const SubscriptionModalQueryParams = {
  subscribe: '' as string | undefined,
  companyId: '' as string | undefined,
  companyName: '' as string | undefined,
  tier: '' as SubscriptionTier | undefined,
  code: '' as string | undefined,
  success: '' as string | undefined,
} as const;

export type SubscriptionModalQueryParams = typeof SubscriptionModalQueryParams;

export const subscriptionModalParamKeys = keysOf(SubscriptionModalQueryParams);

export const emptySubscriptionParams = mapValues(
  keyBy(subscriptionModalParamKeys),
  () => undefined,
) as SubscriptionModalQueryParams;
